module.exports = __webpack_public_path__ + "img/zhuanpan.7f9731b2.png";